export const establishWebSocket = (token, device_type) => {
    let urlBase;

    if (process.env.REACT_APP_WEBSOCKET_URL) {
        urlBase = process.env.REACT_APP_WEBSOCKET_URL;
    } else {
        const loc = window.location;
        urlBase = `${loc.protocol === "https:" ? 'wss' : 'ws'}://${loc.host}${process.env.REACT_APP_SERVER_URL}`;
    }
    const socket = new WebSocket(`${urlBase}backend/websocket/?token=${token}&device_type=${device_type}`);

    return socket;
}

export const closeTicket = async (id_ticket, code=null) => {
    if (!id_ticket || !localStorage.getItem('jwt')) {
        console.error("attempting to close when no ticket is active?")
    }

    let fetchState;
    let params = {id_ticket};
    if (code) {
        params.code = code;
    }
    const paramString = new URLSearchParams(params).toString()
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}backend/ticket/close?${paramString}`, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('jwt')}`
        }
    })
    response.ok ? fetchState = await response.json() : fetchState = null;
    return fetchState;
}
